/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import * as Yup from "yup";
import API from "@unisearch/helpers/api";
import { FileColumnFormater } from "@unisearch/helpers/tableHelpers";
import { swalError, swalSuccess } from "@unisearch/helpers";

const initialData = {
  mediaName: "",
  alt: "",
  src: "",
};

export const MediaForm = ({ drawerHandler, mediaManagerId }) => {
  const [loading, setLoading] = useState(false);
  const [singleItem, setSingleItem] = useState(initialData);

  // Validation schema
  const validationSchema = Yup.object().shape({
    mediaName: Yup.string().required("Field is required"),
    alt: Yup.string().required("Field is required"),
  });

  //get single item data for edit
  const getSingleData = async () => {
    await API.get(`/media-manager/${mediaManagerId}`)
      .then((res) => {
        if (!res.error) {
          setSingleItem(res.data);
        }
      })
      .catch((error) => {
        swalError(error);
      });
  };

  //get single data
  useEffect(() => {
    if (mediaManagerId) {
      getSingleData();
    }
  }, [mediaManagerId]);

  //store signle data
  const storeData = async (values, action) => {
    let formData = new FormData();
    formData.append("mediaName", values.mediaName);
    formData.append("alt", values.alt);
    formData.append("tag", values.tag);
    if (mediaManagerId) {
      await API.patch(`/media-manager/${mediaManagerId}`, formData)
        .then((res) => {
          if (!res.error) {
            swalSuccess(res.message);
            drawerHandler();
          } else {
            swalError("Upload Failed");
          }
        })
        .catch((error) => {
          swalError(error);
        });
    }
    action.resetForm();
  };

  return (
    <Formik
      initialValues={singleItem}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values, action) => {
        storeData(values, action);
      }}
    >
      {({ handleSubmit, setFieldValue, values, errors, touched }) => {
        return (
          <Form className="form">
            <div className="admin_drawer_container">
              <div className="admin_drawer_head">
                <div className="admin_drawer_head_left">
                  <h3 className="admin_drawer_head_title">Edit Media Item</h3>
                </div>
                <button
                  type="button"
                  className="admin_drawer_head_right"
                  onClick={() => {
                    drawerHandler();
                    setSingleItem(initialData);
                  }}
                >
                  <FiX />
                </button>
              </div>
              <div className="admin_drawer_body_outer">
                <div className="admin_drawer_body">
                  <div className="mediaFlex">
                    <div className="mediaFile">
                      {FileColumnFormater(values.src)}
                    </div>
                    <div className="mediaForm">
                      <div className={`admin_form_group`}>
                        <label htmlFor="course" className={`admin_label`}>
                          File Name <span className="asterisk">*</span>
                        </label>
                        <input
                          type="text"
                          className="admin_input"
                          placeholder="name here..."
                          onWheel={(event) => event.currentTarget.blur()}
                          onChange={(e) => {
                            setFieldValue("mediaName", e.target.value);
                          }}
                          value={values.mediaName ?? ""}
                        />
                        {errors.mediaName && touched.mediaName && (
                          <div className={`invalid-feedback`}>
                            {errors.mediaName}
                          </div>
                        )}
                      </div>
                      <div className={`admin_form_group`}>
                        <label htmlFor="course" className={`admin_label`}>
                          ALT Text <span className="asterisk">*</span>
                        </label>
                        <input
                          type="text"
                          className="admin_input"
                          placeholder="name here..."
                          onWheel={(event) => event.currentTarget.blur()}
                          onChange={(e) => {
                            setFieldValue("alt", e.target.value);
                          }}
                          value={values.alt ?? ""}
                        />
                        {errors.alt && touched.alt && (
                          <div className={`invalid-feedback`}>{errors.alt}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="admin_drawer_footer">
                <div className="admin_drawer_footer_left">
                  <button
                    type="button"
                    className="admin btn btn-cancel"
                    onClick={() => {
                      drawerHandler();
                      setSingleItem(initialData);
                    }}
                  >
                    Cancel
                  </button>
                </div>
                <div className="admin_drawer_footer_right">
                  <button
                    type="button"
                    className="admin btn btn-primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default MediaForm;
